import { Component, Vue } from 'vue-property-decorator';


@Component
export default class CLoadingTest extends Vue {
    private visible = false;
    private appearances = [ null, 'width', 'height', 'size', 'opacity' ];
    private appearance = null;
}